import { IStaff } from '../../api/types/_staff';
import { createSlice } from "@reduxjs/toolkit";
import { getTimeWorking } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";

export interface IState {
  lstTimeWorking: ResponseData<IStaff[]> & PaginationResponse | null,
  isTimeWorkingLoading: boolean,
  isTimeWorkingSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  lstTimeWorking: null,
  isTimeWorkingLoading: false,
  isTimeWorkingSuccess: false,

  error: {},
};

const TimeWorkingSlice = createSlice({
  name: "time_working",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTimeWorking.pending, (state: IState, action: any) => {
      state.isTimeWorkingLoading = true
    });
    builder.addCase(getTimeWorking.fulfilled, (state: IState, action: any) => {
      state.lstTimeWorking = action.payload.data;
      state.isTimeWorkingSuccess = true;
      state.isTimeWorkingLoading = false;
    });
    builder.addCase(getTimeWorking.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isTimeWorkingSuccess = false;
      state.isTimeWorkingLoading = false;
    });
  },
});

export default TimeWorkingSlice.reducer;